<template>
  <section>
    <div class="header mb-3 mt-3 p-0 md:p-2 ml-8 md:ml-0">
      <h2 class="font-bold text-gray-700 text-xl">
        <i class="bx bxs-credit-card-front text-indigo-500 -m-8 mr-1"></i>
        MÉTODO DE PAGAMENTO
      </h2>
      <small class="text-gray-600">Escolha o seu método de pagamento abaixo</small>
    </div>
    <ValidationProvider rules="required" v-slot="{ errors }">
      <div class="mb-2" :data-check="false">
          <payment-card
            @click.native="doPaymentSelect(1)"
            :selected="paymentSelect  == 1 ? true : false"
            name="Cartão de Crédito"
            icon="bxs-credit-card"
          >
            <template v-slot:form v-if="paymentSelect  === 1">
              <div class="border-t md:px-6 md:py-8 p-3 flex flex-wrap bg-gray-200">
                <div class="w-full p-1">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for class="text-sm font-bold">Nome no Cartão:</label>
                    <t-input
                      name="card_holdername"
                      v-model="cardHolderName"
                      :variant="errors.length > 0 ? 'danger' : 'credit' "
                      class="w-full"
                      placeholder="Nome no cartão:"
                    />
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="w-full p-1">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for class="text-sm font-bold">N° do Cartão:</label>
                    <t-input
                      name="my-input"
                      v-model="cardBin"
                      @change="getInstallments()"
                      class="w-full"
                      :variant="errors.length > 0 ? 'danger' : 'credit' "
                      placeholder="Numero do cartão:"
                      v-mask="['#### #### #### ####']"
                    />
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="w-full md:w-1/3 p-1">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for class="text-sm font-bold">Data de Nascimento:</label>
                    <t-input
                      name="my-input"
                      v-model="cardBirthDate"
                      class="w-full"
                      :variant="errors.length > 0 ? 'danger' : 'credit' "
                      placeholder="Dia/Mês/Ano:"
                      v-mask="['##/##/####']"
                    />
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="w-1/2 md:w-1/3 p-1">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for class="text-sm font-bold">Validade:</label>
                    <t-input
                      name="my-input"
                      v-model="cardDueDate"
                      class="w-full"
                      :variant="errors.length > 0 ? 'danger' : 'credit' "
                      placeholder="Mês/Ano:"
                      v-mask="['##/##']"
                    />
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="w-1/2 md:w-1/3 p-1">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for class="text-sm font-bold">CVV:</label>
                    <t-input
                      name="my-input"
                      v-model="cardCvv"
                      class="w-full"
                      :variant="errors.length > 0 ? 'danger' : 'credit' "
                      placeholder="CVV:"
                      v-mask="['###', '####']"
                    />
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="w-full p-1">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label for class="text-sm font-bold">Parcelas:</label>
                    <t-select
                    :variant="errors.length > 0 ? 'danger' : '' "
                    placeholder="Selecione..." class="w-full" :options="options" v-model="cardPlots" id="installments" name="installments"></t-select>
                    <span class="text-red-500 block pt-1" v-if="errors.length">
                      <i class="bx bx-error mr-1"></i>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
            </template>
          </payment-card>
      </div>
      <div class="mb-8">
        <payment-card
          name="Boleto"
          @click.native="doPaymentSelect(2)"
          :selected="paymentSelect  == 2 ? true : false "
          icon="bxs-barcode"
        >
          <template v-slot:form v-if="paymentSelect  === 2">
            <div class="border-t md:px-6 md:py-8 p-3 flex flex-wrap bg-gray-200">
              <div class="w-full">
                <p>
                  Total a ser pago
                  <strong>{{ $store.state.total_price | toCurrency}}</strong>
                </p>
              </div>
            </div>
          </template>
        </payment-card>
      </div>
      <span class="text-red-500 block pb-1 mb-2" v-if="errors.length">
        <i class="bx bx-error mr-1"></i>
        {{ errors[0] }}
      </span>
      <input type="hidden" name="paymentSelect" v-model="paymentSelect">
    </ValidationProvider>
  </section>
</template>

<script>
import creditCardType from 'credit-card-type'
import PaymentCard from '@/components/PaymentCard'

export default {
  components: {
    PaymentCard
  },
  computed: {
    cardHolderName: {
      get () {
        return this.$store.state.cardHolderName
      },
      set (value) {
        this.$store.state.cardHolderName = value
      }
    },
    paymentSelect: {
      get () {
        return this.$store.state.paymentSelect
      },
      set (value) {
        this.$store.state.paymentSelect = value
      }
    },
    cardBin: {
      get () {
        return this.$store.state.cardBin
      },
      set (value) {
        this.$store.state.cardBin = value
      }
    },
    cardCvv: {
      get () {
        return this.$store.state.cardCvv
      },
      set (value) {
        this.$store.state.cardCvv = value
      }
    },
    cardDueDate: {
      get () {
        return this.$store.state.cardDueDate
      },
      set (value) {
        this.$store.state.cardDueDate = value
      }
    },
    cardPlots: {
      get () {
        return this.$store.state.cardPlots
      },
      set (value) {
        this.$store.state.cardPlots = value
      }
    },
    cardBirthDate: {
      get () {
        return this.$store.state.cardBirthDate
      },
      set (value) {
        this.$store.state.cardBirthDate = value
      }
    }
  },
  data () {
    return {
      options: null
    }
  },
  methods: {
    getInstallments () {
      if (this.cardBin.length >= 16) {
        const card = {
          brand: creditCardType(this.cardBin)[0].type,
          number: this.cardBin,
          total: this.$store.state.total_price
        }
        window.payment.getInstallments(this.$route.params.token, card).then((response) => {
          this.options = response
        })
        return true
      }
      this.options = []
    },
    doPaymentSelect (value) {
      this.paymentSelect = value
    }
  }
}
</script>

<style>
</style>
